import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { getPendingCount } from "@/services/approvalService";
import { getUnresolvedCount } from "@/services/syncFailureService";

export function useAdminSidebarCounts(): Record<string, number> {
  const { data: approvalCount = 0 } = useQuery({
    queryKey: ["approval-pending-count"],
    queryFn: getPendingCount,
    refetchInterval: 30000,
  });

  const { data: bugCount = 0 } = useQuery({
    queryKey: ["sidebar-bug-count"],
    queryFn: async () => {
      const { count } = await supabase
        .from("bug_reports")
        .select("id", { count: "exact", head: true })
        .eq("status", "open");
      return count ?? 0;
    },
    refetchInterval: 30000,
  });

  const { data: supportCount = 0 } = useQuery({
    queryKey: ["sidebar-support-count"],
    queryFn: async () => {
      const { count } = await supabase
        .from("support_tickets")
        .select("id", { count: "exact", head: true })
        .eq("status", "open");
      return count ?? 0;
    },
    refetchInterval: 30000,
  });

  const { data: applicationCount = 0 } = useQuery({
    queryKey: ["sidebar-application-count"],
    queryFn: async () => {
      const { count } = await supabase
        .from("job_applications")
        .select("id", { count: "exact", head: true })
        .eq("status", "new");
      return count ?? 0;
    },
    refetchInterval: 30000,
  });

  const { data: bookingCount = 0 } = useQuery({
    queryKey: ["sidebar-booking-count"],
    queryFn: async () => {
      const { count } = await supabase
        .from("studio_bookings")
        .select("id", { count: "exact", head: true })
        .eq("status", "pending");
      return count ?? 0;
    },
    refetchInterval: 30000,
  });

  const { data: failedSyncCount = 0 } = useQuery({
    queryKey: ["sidebar-failed-sync-count"],
    queryFn: getUnresolvedCount,
    refetchInterval: 30000,
  });

  return {
    "/admin/approval-queue": approvalCount,
    "/admin/bugs": bugCount,
    "/admin/support": supportCount,
    "/admin/job-applications": applicationCount,
    "/admin/studio-bookings": bookingCount,
    "/admin/failed-syncs": failedSyncCount,
  };
}
